<template>
    <div class="courseplayer">
        <!-- 登录 -->
        <loginframe v-if="login" @login="loginChange($event)"></loginframe>
        <!-- 学习结束弹出页  -->
        <learnover v-show="over"></learnover>
        <!-- 评价 -->
        <div class="grade" v-show="grade">
            <div class="grade-wrap">
                <div style="width:100%;height:23px;line-height:23px;font-size:23px;text-align:center;margin:50px 0 32px 0;">课程评价</div>
                <ul style="width:250px;margin:0 auto;">
                    <li v-for="n in 5" :key="n" @mouseover="mouseOver(n)" @click="selected('评论',n)" style="float:left;margin:0 9px;"> 
                        <img v-show="current >= n" src="../../static/courseplayer/heart_red.jpg" alt="">
                        <img v-show="current < n" src="../../static/courseplayer/heart_gray.jpg" alt="">
                    </li>
                </ul>
            </div>
        </div>
        <!-- 查看错题 -->
        <div class="errorbook" v-show="errorbook">
            <div class="errorbook-wrap">
                <div style="width:100%;height:40px;line-height:40px;font-size:18px;font-weight:bold;text-align:center;color:black;">我的错题</div>
                <div style="height:254px;overflow:auto;background:#f3f3f3;margin:20px;">
                    <div v-for="(item, index) in errorList" :key='index'>
                        <div style="font-size:16px;color:black;">{{index+1}}.{{item.tmQuestionContent}}</div>
                        <div style="font-size:14px;color:black;margin-left:20px;margin-top:4px;color:#333;" v-for="(itemb, index) in item.questionOptionVoList" :key='index'>{{itemb.optLetter}}.{{itemb.optContent}}</div>
                        <div style="color:black;font-weight:bold;">正确答案：{{item.rightOpt}}</div>
                    </div>
                </div>
                <div style="width:200px;overflow:hidden;margin:0 auto;">
                     <div class="errorbook-wrap-btn" style="float:right;background:#f2981e;" @click="retest(1)">重新考试</div>
                    <div class="errorbook-wrap-btn" @click="()=>{this.errorbook=false;this.$router.go(0)}">重新观看</div>
                </div>
               
            </div>
        </div>
        <!-- 答题结束 -->
        <div class="answerok" v-show="answerok">
            <div class="answerok-wrap">
                <div style="width:100%;height:18px;line-height:18px;font-size:18px;text-align:center;margin:120px 0 60px 0;color:#f2981d;">您的本次考核成绩不合格（得分{{totalScore/100}}分）</div>
                <div style="width:215px;height:33px;margin:0 auto;">
                    <div style="float:left;width:87px;height:33px;line-height:33px;text-align:center;background:#0ca8e1;color:#fff;cursor:pointer;" @click="lookErrors">查看错题</div>
                    <div style="float:right;width:87px;height:33px;line-height:33px;text-align:center;background:#ef991e;color:#fff;cursor:pointer;" @click="retest">重新考试</div>
                </div>
            </div>
        </div>
        <!-- 答题 -->
        <div class="answer" v-if="answer">
            <div class="answer-wrap">
                <div style="width:100%;height:62px;line-height:62px;text-align:center;border-bottom:1px solid #a0a0a0;">第&nbsp;{{questionIndex+1}}&nbsp;题</div>
                <div style="width:100%;height:106px;padding:0px 108px;font-size:22px;color:black;padding-top:10px;">{{this.questionList[this.questionIndex].tmQuestionContent}}</div>
                <!-- 选项框 -->
                <div style="width:780px;height:180px;padding-left:52px;margin:0 auto;padding-top:16px;background:#eeeeee;overflow:auto;">
                    <div style="width:100%;height:auto;overflow:hidden;margin-bottom:8px;" v-for="(item, index) in questionList[questionIndex].questionOptionVoList" :key='index'>
                        <div class="selsctletter" :style="selsctletterStyleIndex == index?selsctletterStyle:''" @click="selectLetterFn(index,item.optNo,item.questionNo,item.recordNo)">
                            {{item.optLetter}}
                        </div>
                        <div style="float:left;width:auto;height:28px;line-height:28px;font-size:17px;color:#232323;">
                            {{item.optContent}}
                        </div>
                    </div>
                </div>
                <div style="width:780px;height:34px;margin:0 auto;margin-top:40px;">
                    <div style="float:left;">答题进度{{questionIndex+1}}/{{questionList.length}}</div>
                    <div class="quitbtn" @click="quitAnswer()" v-show="questionIndex == 0">退出</div>
                    <div class="nextbtn" @click="nextQuestion()" v-show="questionIndex != questionList.length -1">下一题</div>
                    <div class="quitbtn" @click="quitAnswer(1)" v-show="questionIndex == questionList.length -1">提交</div>
                </div>
            </div>
        </div>
        <tab></tab>
        <!-- 面包屑 -->
        <!-- <div style="width:1200px;margin:0 auto;height:82px;line-height:82px;font-size:15px;" @click="toAnswer()">当前位置：首页>职业技能类>详情播放视频</div> -->
        <div style="height:46px;"></div>
        <bannerplayer :videoCode='videoCode' :videoUrl='videoUrl' :recommendList='recommendList'  :videoStartTime='videoStartTime' @event="change"></bannerplayer>
        <!-- <bannerbottom :videoBottom='videoBottom'></bannerbottom> -->
        <!-- 播放器底部 -->
        <div class="playerbottom">
            <div class="playerbottom-wrap">
                <div class="playerbottom-w-item" v-for="(item, index) in videoBottom" :key='index'>
                    <div style="height:176px;width:100%;" @click="toPlay(item.videoNo,'')">
                        <img :src="item.coverUrl" alt="">
                    </div>
                    <div class="playerbottom-i-content">
                        {{item.name}}:&nbsp;{{item.baseRemark}}
                    </div>
                    <div class="playerbottom-i-c">
                        <div style="float:left;margin-right:132px;margin-left:10px;">{{(item.timeLen/60).toFixed(0)}}分钟</div>
                        <div style="float:left;">{{item.studyNum}}人已学</div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
    import tab from '../common/tab.vue'
    import bannerplayer from './detail/bannerplayer.vue'
    //  import bannerbottom from './detail/bannerbottom.vue'
    //import loginframe from '../login/loginframe'
    import learnover from './detail/learnover'

    export default {
        name: "courseplayer",
        components:{
            tab,
            bannerplayer,
            // bannerbottom,
            loginframe,
            learnover,
        },
        data () {
            return {
                answer:false,
                answerok:false,
                grade:false,
                over:false,
                errorbook:false,  //查看错题
                questionList:[
                    {title:'哪个答案更贴近你的感受',question:'当你外出一整天，你会？',selsct:["文字A","文字B"]},
                    {title:'哪个答案更贴近你的感受2',question:'当你外出一整天，你会不会？',selsct:["文字A","文字B","C"]},
                    {title:'哪个答案更贴近你的感受3',question:'当你外出一整天，你会不会呢？',selsct:["文字A","文字B","C","D"]},
                ],
                questionIndex:0,
                selsctLetter:["A","B","C","D"],
                selsctletterStyle:'',
                selsctletterStyleIndex:66,
                current:-1,
                recordNo:'', //试题编号
                questionNo:'',//题目编号
                optNos:'',//选项编号
                videoUrl:'Http://dongyunqichuang.oss-accelerate.aliyuncs.com/muke/video/5c057fd33b6f442f8bd1a6a95e00f55c/d02c5bbca2d648eeb7bc79715ffd949e.m3u8',  //视频地址
                catalogueId:0, //分类id，答题接口
                courseId:0,    //课程id，答题接口
                videoBottom:[], //视频框底部
                recommendList:[], //视频相关推荐
                errorList:[],
                videoCode :'',  //视频编码
                videoStartTime:'',  //视屏开始时间
                login:false,  //登录框
                totalScore: 0,  //答题总分数 
                timeout:'',  //定时器

            };
        },
        methods: {
            scrollTop(){
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                let scrollLength = document.documentElement.scrollHeight;
                let clientHeight = document.documentElement.scrollHeight;
                if(scroll != 0){
                    document.documentElement.scrollTop = 0;
                }
            },
            
            //答题
            toAnswer(){
                if(localStorage.token){
                    this.answer = true;
                }else{
                    this.$Message.warning('您还没有登录！');
                }
            },
            //提交
            quitAnswer(s){
                this.answer = false;
                this.answerok = false;
                this.questionIndex = 0;
                this.selsctletterStyleIndex = 99;
                if(s){
                    this.answerok = true;
                    this.$axios.post("/v1/muke/student/question/commitQuestionAnswer",{
                        recordNo:this.recordNo, 
                        questionNo:this.questionNo,
                        optNos:this.optNos,
                    }).then(({data})=>{
                        if(data.data){
                            this.totalScore = data.data.totalScore;
                        }
                    })
                }
                
            },
            nextQuestion(){
                if(this.questionIndex < this.questionList.length -1){
                    this.questionIndex ++;
                }
                this.selsctletterStyleIndex = 99;

                this.$axios.post("/v1/muke/student/question/insertQuestionAnswer",{
                    recordNo:this.recordNo, 
                    questionNo:this.questionNo,
                    optNos:this.optNos,
                }).then(({data})=>{
                    if(data.code == 200){
                        this.questionNo = '';
                        this.optNos = '';
                    }
                })
            },
            selectLetterFn(s,optNos,questionNo,recordNo){
                this.selsctletterStyle = 'border:1px solid #0da7e3;background:#0da7e3;color:#fff';
                this.selsctletterStyleIndex = s;
                // this.recordNo =  recordNo; //试题编号
                this.questionNo = questionNo;//题目编号
                this.optNos = optNos; //选项编号

            },
            //评价
            selected(msg,n){
                this.current = n;
                this.grade = false;
                this.answer = true;
                this.$axios.post("/v1/muke/student/video/comment",{
                    catalogueId:this.catalogueId,   //类目id
                    courseId:this.courseId,
                    score:n, //得分
                }).then(({data})=>{
                    
                })
            },
            mouseOver(n){
               this.current = n;
            },
            //登录子组件
            change(a,b,list){
                if(a){
                    //视频结束
                    if(localStorage.token){
                        // this.grade = a; //评价弹框
                        //学习完成弹框
                        // this.over = a;
                        // this.timeout = setTimeout(()=>{
                        //     console.log(88,list);
                        //     this.over = false;
                        // }, 2000);
                        console.log(list);
                        if(list){
                            this.questionList = list;
                            this.recordNo = list[0].recordNo;
                            // this.answer = true;
                            this.grade = true;
                        }
                        
                    }else{
                        this.$Message.warning('您还没有登录！');
                    }
                }else if(b){
                    this.login = true;
                }
                
            },
            //登录组件
            loginChange(s){
                console.log('444',s);
                this.login = s;
                
            },
            //播放器底部点击播放
            toPlay(code,url){
                this.videoCode = code;
                //根据视频编号获取视频地址
                this.$axios.post("/v1/muke/student/video/selectVideo",{
                    videoNo:code, 
                }).then(({data})=>{
                    if(data.code == 200){
                        this.videoStartTime = data.data.progressTime;
                        this.videoUrl = data.data.videoUrl;
                    }
                })
            },
            //查看错题
            lookErrors(){
                this.answerok = false;
                this.$axios.post("/v1/muke/student/question/selectRightQuestionAnswer",{
                    recordNo:this.recordNo, 
                }).then(({data})=>{
                    if(data.data){
                        this.errorList = data.data;
                        this.errorbook=true;
                    }
                })
            },
            //重新考试 √
            retest(errorbook){
                if(errorbook){
                    this.errorbook = false;
                    if(this.courseId && this.catalogueId){
                        this.$axios.post("/v1/muke/student/question/getPaper",{
                            courseId:this.courseId,   //获取章节,课程id
                            catalogueId:this.catalogueId, //获取章节
                        }).then(({data})=>{
                            if(data.data){
                                this.questionList = data.data;
                                this.recordNo = data.data[0].recordNo; //试题编号
                                this.answer = true;
                            }
                        })
                    }
                }else{
                    this.answerok = false;
                    if(this.courseId && this.catalogueId){
                        this.$axios.post("/v1/muke/student/question/getPaper",{
                            courseId:this.courseId,   //获取章节,课程id
                            catalogueId:this.catalogueId, //获取章节
                        }).then(({data})=>{
                            if(data.data){
                                this.questionList = data.data;
                                this.recordNo = data.data[0].recordNo; //试题编号
                                this.answer = true;
                            }
                        })
                    }
                }
                
            },
           
        },
        created(){
            let query = this.$route.query; 
            this.catalogueId = query.id;
            this.videoCode = query.code;
            //获取视频地址
            this.$axios.post("/v1/muke/student/video/selectVideo",{
                videoNo:query.code, 
            }).then(({data})=>{
                if(data.data){
                    this.videoStartTime = data.data.progressTime;
                    this.videoUrl = data.data.videoUrl;
                    this.videoBottom = data.data.videoVoList;
                    this.courseId = data.data.courseId;
                }
            })
            //视频课堂相关推荐
            this.$axios.post("/v1/muke/student/video/selectVideoRecommend",{
                videoNo:query.code, 
                num:6,
            }).then(({data})=>{
                if(data.data){
                    this.recommendList = data.data;
                }
            })
            //重新答题
            // this.$axios.post("/v1/muke/student/question/getPaper",{
            //     // videoNo:"48u543ek",
            //     videoNo:query.code,  //单个视频
            //     // courseId:"77",   //获取章节,课程id
            //     // catalogueId:"31", //不用传

            // }).then(({data})=>{
            //     if(data.data){
            //         this.questionList = data.data;
            //         this.recordNo = data.data[0].recordNo; //试题编号
            //     }
            // })
            
        },
        mounted(){
            this.scrollTop();


            //查看错题
            this.$axios.post("/v1/muke/student/question/selectRightQuestionAnswer",{
                recordNo:this.recordNo, 
            }).then(({data})=>{
                if(data.data){
                    
                }
            })  
        },
        beforeDestroy() {
           clearInterval(this.timeout)
        }
    }
</script>

<style scoped lang="less">
    .courseplayer{
        width:100%; background:#f7f7f7;
    }
    .answer{
        -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Chrome/Safari/Opera */
        -khtml-user-select: none; /* Konqueror */
        -moz-user-select: none; /* Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
        user-select: none;

        position:fixed;width:100%;height:100%;top:0px;z-index:44;
        background:rgba(0,0,0,0.5);
        .answer-wrap{
            position:absolute;top:0px;bottom:0px;left:0px;right:0px;margin:auto;
            width:1010px;height:468px;background:white;
            .selsctletter{
                float:left;width:28px;height:28px;line-height:28px;font-size:17px;text-align:center;border:1px solid #acacac;border-radius: 50%;margin-right:12px;
            }
            .quitbtn{
                float:right;cursor: pointer;width:90px;height:34px;line-height:34px;text-align:center;color:white;background:#f2981e;margin-left:40px;
            }
            .nextbtn{
                float:right;cursor: pointer;width:86px;height:34px;line-height:34px;text-align:center;color:white;background:#0ca8e1;
            }
        }
    }
    .answerok{
        position:fixed;width:100%;height:100%;top:0px;z-index:44;
        background:rgba(0,0,0,0.5);
        .answerok-wrap{
            position:absolute;top:0px;bottom:0px;left:0px;right:0px;margin:auto;
            width:776px;height:290px;background:white;
        }
    }
    .grade{
        position:fixed;width:100%;height:100%;top:0px;z-index:44;
        background:rgba(0,0,0,0.5);
        .grade-wrap{
            position:absolute;top:0px;bottom:0px;left:0px;right:0px;margin:auto;
            width:556px;height:204px;background:white;
        }
    }
    .errorbook{
        position:fixed;width:100%;height:100%;top:0px;z-index:44;background:rgba(0,0,0,0.5);
        .errorbook-wrap{
            position:absolute;top:0px;bottom:0px;left:0px;right:0px;margin:auto;
            width:776px;height:400px;background:white;
        }
        .errorbook-wrap-btn{
            cursor: pointer;width:90px;height:34px;line-height:34px;text-align:center;color:white;margin:0 auto;margin-top:10px;float:left;background:#0ca8e1;
        }
    }
    .playerbottom{
        width:1200px; margin:0 auto;height:auto;overflow: hidden;
        .playerbottom-wrap{
            height:auto;margin-bottom:80px;overflow: hidden;
            .playerbottom-w-item{
                float:left;width:283px;height:272px;background:#fff;
                margin-left:22px;margin-bottom:10px;
                img{display: block;width: 100%;height:100%;}
                .playerbottom-i-c{
                    width:100%;height:15px;font-size:15px;margin-top:17px;
                }
                .playerbottom-i-content{
                    line-height:15px;font-size:15px;color:#1c1f21;margin-top:17px;
                    height:auto;overflow: hidden;padding:0 10px;
                    // width:362px;
                }
            }
            .playerbottom-w-item:nth-of-type(4n+1){
                margin-left:0px;
            }
        }
    }
</style>
